import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
  root: {
    width: theme.spacing(50)
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: '1rem',
    width: '100%',
    justifyContent: 'space-between',
    position: 'relative',
    height: '100%'
  }
});

const roundNumString = (value, places) => {
  return value ? value.toLocaleString(undefined, {
    minimumFractionDigits: places,
    maximumFractionDigits: places
  }) : 'N/A';
};
const CensusTractInfo = ({ classes, propertyCT }) => {
  return (
    <div className={classes.root}>
      <Tooltip title="Census Tract Information" placement="top">
        <div className={classes.container}>
          <div className={classes.statBlock}>
            {/** TODO: med income is shown in aux info. decide on where to put <Typography variant="caption">
            <strong>Med Income</strong> $
            {roundNumString(propertyCT.median_Income, 2)}
          </Typography>
        */}
            <Typography variant="caption" display='block'>
              <strong>Afford Price</strong>{' '}
              {propertyCT.AffordabilityPrice ? '$' + roundNumString(propertyCT.AffordabilityPrice, 0) : '-'}
            </Typography>
            <Typography variant="caption" display='block'>
              <strong>Sales Count</strong>{' '}
              {propertyCT.SalesCount ? propertyCT.SalesCount : '-'}
            </Typography>
          </div>

          <div className={classes.statBlock}>
            <Typography variant="caption" display='block'>
              <strong>Afford Pmt</strong>{' '}
              {propertyCT.AffordabilityPmt ? '$' + roundNumString(propertyCT.AffordabilityPmt, 0) : '-'}
            </Typography>
            <Typography variant="caption" display='block'>
              <strong>Afford Score</strong>{' '}
              {propertyCT.AffordabilityScore ? roundNumString(propertyCT.AffordabilityScore, 2) : '-'}
            </Typography>
          </div>

          <div className={classes.statBlock}>
            <Typography variant="caption" display='block'>
              <strong>Wealth</strong>{' '}
              {propertyCT.Wealth ? roundNumString(propertyCT.Wealth, 2) : '-'}
            </Typography>
            <Typography variant="caption" display='block'>
              <strong>Crime Index</strong>{' '}
              {propertyCT.CrimeIndex ? roundNumString(propertyCT.CrimeIndex, 2) : '-'}
            </Typography>
          </div>
        </div>
      </Tooltip >
    </div >
  );
};

export default withStyles(styles)(CensusTractInfo);
